// @ts-nocheck
const rootRoutes = [
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['../../components/Login.vue'], resolve)
  },
  {
    // bms打开页面查看分销账户统计信息
    path: '/bmsAgentStatistics',
    name: 'bmsAgentStatistics',
    component: resolve =>
      require(['../../components/AgentStatistics.vue'], resolve)
  },
  {
    path: '/37473607-a5a4-4337-b24e-3a147920203d',
    name: '37473607-a5a4-4337-b24e-3a147920203d',
    component: resolve =>
      require([
        '../../components/37473607-a5a4-4337-b24e-3a147920203d.vue'
      ], resolve)
  },
  {
    path: '/loginerror',
    name: 'loginerror',
    component: resolve =>
      require(['../../components/global/dingtalk/dingtalkError.vue'], resolve)
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: resolve =>
      require(['../../components/account/welcome.vue'], resolve),
    meta: {
      exclude: ['guest']
    }
  },
  {
    path: '/error',
    component: resolve =>
      require(['../../components/global/error.vue'], resolve)
  },
  {
    path: '/forgetPassword',
    component: resolve =>
      require(['../../components/account/forgetPassword.vue'], resolve),
    meta: {
      exclude: ['guest']
    }
  },
  {
    path: '/setPassword',
    name: 'setPassword',
    component: resolve =>
      require(['../../components/account/setPassword.vue'], resolve),
    meta: {
      exclude: ['guest']
    }
  },
  {
    path: '',
    component: resolve => require(['../../components/Home.vue'], resolve),
    redirect: {
      path: '/search'
    },
    children: [
      {
        path: '/search',
        name: 'search',
        component: resolve => require(['../../components/Search.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '挖掘线索'
        }
      },
      {
        path: '/mapSearch',
        name: 'mapSearch',
        component: resolve =>
          require(['../../components/mapSearch.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent'],
          title: '地图线索'
        }
      },
      {
        path: '/album',
        component: resolve => require(['../../components/album.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '专辑'
        }
      },
      {
        path: '/exportRecord',
        component: resolve =>
          require(['../../components/exportRecord.vue'], resolve),
        meta: {
          exclude: ['guest'],
          title: '导出记录'
        }
      },
      {
        path: '/album/:id',
        component: resolve =>
          require(['../../components/albumDetail.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '专辑'
        }
      },
      {
        path: '/sea',
        name: 'sea',
        component: resolve => require(['../../components/Sea.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '公海'
        }
      },
      {
        path: '/pool',
        component: resolve => require(['../../components/Pool.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '' //我的线索
        }
      },
      {
        path: '/callRecords',
        component: resolve =>
          require(['../../components/callRecords.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '呼叫中心'
        }
      },
      {
        path: '/speechRobot',
        component: resolve =>
          require(['../../components/speechRobot.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '语音机器人'
        }
      },
      {
        path: '/task',
        component: resolve => require(['../../components/Task.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '任务中心'
        }
      },
      {
        path: '/recycle',
        name: 'recycle',
        component: resolve =>
          require(['../../components/Recycle.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'guest'],
          title: '回收站'
        }
      },
      {
        path: '/user',
        name: 'user',
        component: resolve => require(['../../components/User.vue'], resolve),
        meta: {
          exclude: ['subaccount', 'person', 'guest'],
          title: '用户管理'
        }
      },
      {
        path: '/flow_packet',
        name: 'flow_packet',
        component: resolve =>
          require(['../../components/setting/flow_packet.vue'], resolve),
        meta: {
          exclude: [
            'admin',
            'agent',
            'subaccount',
            'customer',
            'bigcustomer',
            'manager',
            'person',
            'subaccount_thirdParty',
            'guest'
          ],
          title: '流量包设置'
        }
      },
      {
        path: '/plan',
        component: resolve =>
          require(['../../components/global/Plan.vue'], resolve),
        meta: {
          exclude: [
            'admin',
            'agent',
            'mainaccount',
            'subaccount',
            'customer',
            'bigcustomer',
            'manager',
            'person',
            'mainaccount_thirdParty',
            'subaccount_thirdParty',
            'guest'
          ],
          title: '套餐配置'
        }
      },
      {
        path: '/broadCast',
        component: resolve =>
          require(['../../components/global/broadCast.vue'], resolve),
        meta: {
          exclude: [
            'admin',
            'agent',
            'mainaccount',
            'subaccount',
            'customer',
            'bigcustomer',
            'manager',
            'person',
            'mainaccount_thirdParty',
            'subaccount_thirdParty',
            'guest'
          ],
          title: '广播通知'
        }
      },
      {
        path: '/account',
        name: 'account',
        component: resolve =>
          require(['../../components/personal/index.vue'], resolve),
        redirect: '/account/personalInfo',
        children: [
          {
            path: 'personalInfo',
            name: 'personalInfo',
            component: resolve =>
              require(['../../components/personal/personalInfo.vue'], resolve),
            meta: {
              exclude: [
                /*  'mainaccount_thirdParty',*/
                /*  'subaccount_thirdParty',*/
                'guest'
              ],
              title: '个人中心'
            }
          }
        ]
      },
      {
        path: '/report/:id',
        // component: resolve => require(['../../components/Report.vue'], resolve),
        component: resolve =>
          require(['../../components/DetailPage.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent'],
          title: '企业详情'
        }
      },
      {
        path: '/square',
        name: 'square',
        component: resolve => require(['../../components/square.vue'], resolve),
        meta: {
          exclude: ['admin', 'agent', 'customer']
        }
      },
      {
        // 查看分销账户统计信息
        path: '/agentStatistics',
        name: 'agentStatistics',
        component: resolve =>
          require(['../../components/AgentStatistics.vue'], resolve),
        meta: {
          exclude: ['agent']
        }
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/term_of_use',
    component: resolve =>
      require(['../../components/global/term_of_use.vue'], resolve)
  },
  {
    path: '*',
    redirect: {
      path: '/login'
    }
  }
];

export default rootRoutes;



// WEBPACK FOOTER //
// ./src/router/role/all.js